import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'rms-hsr-flag',
    templateUrl: './hsr-flag.component.html',
    styleUrls: ['./hsr-flag.component.scss'],
    standalone: false
})
export class HsrFlagComponent implements OnInit {

  @Input() size: 'xs' | 's' | 'm' | 'l' = 's';
  @Input() type: 'H' | 'B';
  @Input() color: string;
  public fontSize: string;

  constructor() {
  }

  ngOnInit() {
    this.color = !this.color ? this.type === 'H' ? '#900' : '#009' : this.color;
    this.fontSize = this.size === 'l' ? '22px' : this.size === 'm' ? '15px' : this.size === 's' ? '12px' : '8px';
  }

}
